import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const FAQSection = () => {
  const { t } = useTranslation();
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      question: t('faq.questions.0.q'),
      answer: t('faq.questions.0.a')
    },
    {
      question: t('faq.questions.1.q'),
      answer: t('faq.questions.1.a')
    },
    {
      question: t('faq.questions.2.q'),
      answer: t('faq.questions.2.a')
    },
    {
      question: t('faq.questions.3.q'),
      answer: t('faq.questions.3.a')
    },
    {
      question: t('faq.questions.4.q'),
      answer: t('faq.questions.4.a')
    }
  ];

  return (
    <section className="py-12 lg:py-24 bg-gray-50 lg:bg-white border-t border-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="font-audiowide text-3xl sm:text-4xl text-[#111111] mb-6">{t('faq.title')}</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-electric-blue to-brand-neon-green mx-auto rounded-full"></div>
        </div>

        <div className="space-y-4 animate-on-scroll">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden hover:border-brand-electric-blue/30 transition-colors"
            >
              <button
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
                className="w-full flex items-center justify-between p-6 bg-white text-left focus:outline-none"
              >
                <span className="font-montserrat font-semibold text-[#111111] text-lg pr-8">{faq.question}</span>
                <div className="shrink-0 w-8 h-8 rounded-full bg-brand-electric-blue/10 flex items-center justify-center text-brand-electric-blue transition-transform duration-300" style={{ transform: openFaq === index ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                  <i className={`fas ${openFaq === index ? 'fa-minus' : 'fa-plus'}`}></i>
                </div>
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="p-6 pt-0 font-montserrat font-normal text-[#4B5563] leading-relaxed border-t border-gray-50">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
